import { OnboardingProvider } from '../context/OnboardingContext'
import { PortalShell } from '../components/PortalShell'
import { WizardErrorBoundary } from '../components/WizardErrorBoundary'
import { TopBar } from '../components/TopBar'
import { WizardToast } from '../components/WizardToast'
import { WizardView } from '../wizard/WizardView'
import { OnboardingThemeProvider } from '../theme/OnboardingThemeProvider'

export function OnboardingPage() {
  return (
    <OnboardingThemeProvider>
      <WizardErrorBoundary>
        <OnboardingProvider>
          <WizardToast />
          <PortalShell heroNarrow heroTitle="Onboarding Wizard" showHeroLogo>
            <TopBar />
            <WizardView />
          </PortalShell>
        </OnboardingProvider>
      </WizardErrorBoundary>
    </OnboardingThemeProvider>
  )
}
